<template>
  <div class="container-size mb-10">
    <v-container>
      <v-row>
        <v-col class="body-terms">
          <h1>{{ title }}</h1>
          <div v-for="(section, index) in termConditionSections" :key="index">
            <h2>{{ section.title }}</h2>
            <div v-html="section.description"></div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      termConditionSections: [],
    };
  },
  metaInfo() {
    const thisPath = window.location.href
    return {
      title: this.$route.meta.title,
      htmlAttrs: { lang: "id", amp: true },
      meta: [
        { name: "description", content: this.$route.meta.description },
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": this.$route.meta.title,
            "url": thisPath
          }
        }
      ]
    };
  },
  watch: {
    "$i18n.locale"() {
      this.fetchTermCondition();
    },
  },
  methods: {
    async fetchTermCondition() {
      try {
        const response = await this.$http.get(`/v1/privacy-policy/syarat--ketentuan`);
        const responseData = response.data.data;
        const content = responseData.privacy_policy.content;
        this.title = responseData.privacy_policy.title
        if (content) {
          this.termConditionSections = content;
        } else {
          throw new Error("Invalid term condition content");
        }
      } catch (error) {
        console.error("Error fetching term condition:", error);
      }
    },
  },
  mounted() {
    this.$gtag.pageview(this.$route);
    this.fetchTermCondition();
  },
};
</script>

<style>
* {
  font-family: "Poppins", sans-serif !important;
}
.body-terms {
  margin-top: 5px;
}

@media screen and (max-width: 900px) {
  .body-privacy {
    margin-top: 10px;
  }
}
</style>